var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { FormatMetric, FormatDimension } from "../";
import { gaTimeDimensions, getLabelFromProps } from "../../resources/functions/";

import Tooltip from "./ChartTooltip";

var TooltipPoints = (_temp2 = _class = function (_Component) {
    _inherits(TooltipPoints, _Component);

    function TooltipPoints() {
        var _temp, _this, _ret;

        _classCallCheck(this, TooltipPoints);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getLabel = function (id, data) {
            var tooltipLabel = _this.props.tooltipLabel;


            console.log('tooltipProps', _this.props);

            var labels = [];

            // label from tooltipLabel        

            if (tooltipLabel) {
                return getLabelFromProps(_extends({}, data, { label: tooltipLabel }));
            }

            // label from id        

            var identifiers = id.split('/');

            identifiers.map(function (key) {

                var keyParts = key.split(':');

                if (keyParts[0] === "startDate" || keyParts[0] === "endDate") {
                    return;
                }

                if (gaTimeDimensions.includes(key)) {
                    return;
                }

                labels.push(key);
            });

            return labels.join(' ');
        }, _this.renderLabel = function (name, index) {

            return React.createElement(
                "i",
                { className: "admin-tooltip__label" },
                React.createElement(FormatMetric, { name: name, key: index })
            );
        }, _this.renderPoint = function (point, index) {
            var _this$props = _this.props,
                dimension = _this$props.dimension,
                metricType = _this$props.metricType;
            var id = point.id,
                color = point.color,
                data = point.data,
                serieId = point.serieId;
            var datetime = data.datetime,
                x = data.x,
                y = data.y;


            console.log('DATA', data);

            var label = _this.getLabel(serieId, data);

            var style = {
                backgroundColor: color
            };

            if (!y) {
                return false;
            }

            return React.createElement(
                "li",
                { key: index },
                React.createElement("div", { className: "admin-tooltip__chip", style: style }),
                label.split(' ').map(_this.renderLabel),
                React.createElement(
                    "i",
                    { className: "admin-tooltip__value" },
                    React.createElement(FormatMetric, { type: metricType, value: y })
                )
            );
        }, _this.renderTitle = function (data) {
            var _this$props2 = _this.props,
                dimension = _this$props2.dimension,
                tooltipTitle = _this$props2.tooltipTitle;


            if (tooltipTitle) {
                var title = getLabelFromProps(_extends({}, data, { label: tooltipTitle }));

                return React.createElement(
                    "h2",
                    { className: "admin-tooltip__title" },
                    title
                );
            }

            var datetime = data.datetime,
                x = data.x;


            var value = void 0;

            if (dimension.startsWith('ga:nth')) {
                value = datetime;
            } else {
                value = x;
            }

            return React.createElement(
                "h2",
                { className: "admin-tooltip__title" },
                React.createElement(FormatDimension, { name: dimension, value: value })
            );
        }, _this.renderSeries = function (series) {
            return React.createElement(
                Tooltip,
                null,
                _this.renderTitle(series[0].data),
                React.createElement(
                    "ul",
                    null,
                    series.map(_this.renderPoint)
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    TooltipPoints.prototype.render = function render() {
        var _props = this.props,
            slice = _props.slice,
            point = _props.point;


        var series = void 0;

        if (slice && slice.points) {
            return this.renderSeries(slice.points);
        }

        if (point) {
            series = this.getSeries([point]);
            return this.renderSeries([point]);
        }

        return React.createElement(
            Tooltip,
            null,
            React.createElement(
                "p",
                null,
                "No points"
            )
        );
    };

    return TooltipPoints;
}(Component), _class.defaultProps = {
    tooltipTitle: undefined,
    tooltipLabel: undefined,
    compare: false
}, _temp2);


export default TooltipPoints;